<template>
  <div
    :style="{cursor: to || this.$listeners.click ? 'pointer' : ''}"
    v-on="$listeners"
    @click="routeAction"
  >
    <v-alert
      :prominent="prominent"
      :color="color"
      :border="border"
      :elevation="elevation"
      :colored-border="coloredBorder"
      :icon="icon"
      :dark="dark"
      :tile="tile"
      :class="[`text-${align}`]"
      :height="height"
      :min-height="minHeight"
      :max-height="maxHeight"
      :width="width"
      :min-width="minWidth"
      :max-width="maxWidth"
      :text="text"
      :outlined="outlined"
      class="ma-0"
    >
      <slot>
        <slot name="title">
          <div
            v-if="title"
            :class="['body-2', titleClass]"
            v-text="title"
          />
        </slot>

        <slot name="subTilte">
          <div
            v-if="subTitle"
            :class="[coloredBorder ? `${color}--text` : '', {'title': prominent}, subTitleClass]"
            v-text="subTitle"
          />
        </slot>
      </slot>
    </v-alert>
  </div>
</template>

<script>
export default {
  name      : 'MiniStatsIconCard',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    prominent: {
      type   : Boolean,
      default: true
    },
    dark: {
      type: Boolean
    },
    tile: {
      type: Boolean
    },
    elevation: {
      type   : String,
      default: '2'
    },
    border: {
      type   : String,
      default: 'left'
    },
    coloredBorder: {
      type   : Boolean,
      default: true
    },
    text: {
      type   : Boolean,
      default: false
    },
    outlined: {
      type   : Boolean,
      default: false
    },
    align: {
      type   : String,
      default: 'center'
    },
    title: {
      type   : [String, Number],
      default: ''
    },
    titleClass: {
      type   : String,
      default: ''
    },
    subTitle: {
      type   : [String, Number],
      default: ''
    },
    subTitleClass: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: 'pink'
    },
    icon: {
      type   : String,
      default: ''
    },
    to: {
      type   : [String, Object],
      default: ''
    },
    height: {
      type   : [String, Number],
      default: 80
    },
    minHeight: {
      type   : [String, Number],
      default: undefined
    },
    maxHeight: {
      type   : [String, Number],
      default: undefined
    },
    width: {
      type   : [String, Number],
      default: undefined
    },
    minWidth: {
      type   : [String, Number],
      default: undefined
    },
    maxWidth: {
      type   : [String, Number],
      default: undefined
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  activated () {},
  deactivated () {},
  beforeDestroy () {},
  destroyed () {},
  methods : {
    routeAction () {
      if (this.to) {
        this.$router.push(this.to)
      }
    }
  }
}
</script>

<style scoped>

</style>
